"use client";

import { useRouter } from "next/navigation";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils/shared/core-utils";

interface MobileBackButtonProps {
  /** 뒤로가기 시 이동할 경로 (선택사항, 없으면 router.back() 사용) */
  fallbackHref?: string;
  /** 추가 클래스명 */
  className?: string;
}

/**
 * 모바일 전용 뒤로가기 버튼 컴포넌트
 * 
 * 데스크톱에서는 숨겨지고, 모바일에서만 표시됩니다.
 * 브라우저 히스토리가 없으면 fallbackHref로 이동합니다.
 */
export function MobileBackButton({ fallbackHref, className }: MobileBackButtonProps) {
  const router = useRouter();

  const handleBack = () => {
    if (window.history.length > 1) {
      router.back();
    } else if (fallbackHref) {
      router.push(fallbackHref);
    } else {
      router.push("/");
    }
  };

  return (
    <button
      onClick={handleBack}
      className={cn(
        "md:hidden flex items-center justify-center w-10 h-10 rounded-full",
        "bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-800",
        "hover:bg-zinc-50 dark:hover:bg-zinc-800 transition-colors",
        "text-zinc-700 dark:text-zinc-300",
        "shrink-0",
        className
      )}
      aria-label="뒤로가기"
    >
      <ArrowLeft className="w-5 h-5" />
    </button>
  );
}

